import { render, staticRenderFns } from "./ProductPreview.vue?vue&type=template&id=99ccc5ee&scoped=true&lang=pug&"
import script from "./ProductPreview.vue?vue&type=script&lang=js&"
export * from "./ProductPreview.vue?vue&type=script&lang=js&"
import style0 from "./ProductPreview.vue?vue&type=style&index=0&id=99ccc5ee&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ccc5ee",
  null
  
)

/* custom blocks */
import block0 from "./ProductPreview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports